import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ListingActionTypes, SearchActionTypes } from '@common/state/features/common.types';
// import analytics from '@utils/analytics';
import ProductFilterContext from '@stone/components/listing/ProductFilterContext';
import CheckboxButton from '@stone/ui/formfields/CheckboxButton';
import analytics from '@stone/utils/analytics';
const SortByOption = (props) => {
    const { inSearch } = useSelector((state) => state.search);
    const isLoading = useSelector((state) => state.loading.requests.indexOf('LISTING') >= 0);
    const { option } = props;
    const dispatch = useDispatch();
    const getRefinementType = () => {
        return inSearch ? SearchActionTypes.UPDATE_SEARCH_REFINEMENT : ListingActionTypes.UPDATE_LISTING_REFINEMENT;
    };
    const sortItems = (option) => {
        dispatch({
            type: getRefinementType(),
            payload: {
                filterAction: 'SORT',
                selectedSort: option === null || option === void 0 ? void 0 : option.sortingRuleId,
            },
        });
    };
    const { selectedSortOption } = useContext(ProductFilterContext);
    return (React.createElement("li", { key: option === null || option === void 0 ? void 0 : option.id, className: "sort__option" },
        React.createElement(CheckboxButton, { type: "radio", name: 'sortoptions-radio', id: `sorting-${option === null || option === void 0 ? void 0 : option.id}`, loading: isLoading, "aria-label": option.displayName, 
            //props.index === 0 add to optain the same behaviour as Moncler but seems strange
            checked: (!selectedSortOption && props.index === 0) || (option === null || option === void 0 ? void 0 : option.id) === (selectedSortOption === null || selectedSortOption === void 0 ? void 0 : selectedSortOption.id), onChange: () => {
                if ((option === null || option === void 0 ? void 0 : option.id) !== (selectedSortOption === null || selectedSortOption === void 0 ? void 0 : selectedSortOption.id)) {
                    analytics.refinementClick('sort by', option === null || option === void 0 ? void 0 : option.id);
                    sortItems(option);
                }
            }, labelAriaHidden: true }, option.displayName)));
};
export default SortByOption;
